import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';
import { LinkableLocationsService, ProfileLocation } from 'src/app/api/linkable-locations.service';

export type LocationDisplayType = "name" | "region"

@Pipe({
    name: 'locationDisplay',
    pure: false,
})
export class LocationDisplayPipe implements PipeTransform {

  value: string = ""
  loading = false
  prevLocationId: string = "-1"

  constructor(
    private locationService: LinkableLocationsService,
    private ref: ChangeDetectorRef
  ) { }

  transform(value: number | string | ProfileLocation | undefined, displayType: LocationDisplayType = "name"): string {
    if (value === undefined) {
      return ""
    }
    let locationId: string

    if (typeof value === "object") {
      locationId = value.id
    }
    else {
      locationId = value.toString();
    }

    if (this.loading === false && locationId !== this.prevLocationId) {
      this.loading = true
      this.prevLocationId = locationId
      this.locationService.getLocationById(locationId).subscribe(
        location => {
          this.value = this.renderLocation(location, displayType)
          this.ref.markForCheck()
          this.loading = false
        }
      )
    }

    return this.value
  }


  private renderLocation(location: ProfileLocation | undefined, displayType: LocationDisplayType) {
    if (!location) {
      return this.unknownValue(this.value)
    }

    switch (displayType) {
      case "name":
        return location.name
      case "region":
        return location.region + (location.domesticRegion ? " " + location.domesticRegion : "")
      default:
        return "" as never
    }
  }

  private unknownValue(value: string) {
    if (value === "") {
      return ""
    }
    else {
      return "unknown location " + value
    }
  }

}
